export default __webpack_public_path__ + "static/media/heirs-logo.5e3ca672.png";